import { OS } from 'ohzi-core';
import { Screen } from 'ohzi-core';

class FontSizeController
{
  constructor()
  {
    this.html_font_size = 13;
    this.html = undefined;
  }

  start()
  {
    this.html = document.querySelector('html');

    this.on_resize();
  }

  on_resize()
  {
    let font_size = 1;

    // let designed_height = OS.is_mobile ? 1080 : 715;
    let designed_height = 715;

    // if (OS.is_mobile)
    // {
    //   font_size = 1 / (715 / this.html.clientWidth);
    //   this.html_font_size = font_size * 16;
    // }
    // else
    // {
    //   console.log(Screen.width, Screen.height);

    // if (Screen.width > Screen.height)
    // {
    font_size = 1 / (designed_height / this.html.clientHeight);
    // }
    // else
    // {
    //   font_size = 1 / (715 / this.html.clientWidth);
    // }
    // }

    // font_size = THREE.Math.clamp(font_size, 0, 1);
    this.html_font_size = font_size * 16;
    // this.html_font_size = Math.round(this.html_font_size);
    // }

    this.html.style.fontSize = `${this.html_font_size}px`;
  }
}

export default new FontSizeController();
